/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Hanly API v2
 * OpenAPI spec version: 0.0.1
 */

import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import { queryOptions as queryOptionsBuilder, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type { ErrorType } from '../../custom-client';

import { customInstance } from '../../custom-client';
import type { DetailError, StandardizedError, UserDetail } from '../hanlyAPIV2.schemas';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getUsersProfileRetrieveUrl = () => {
  return '/api/v2/users/profile';
};

/**
 * サインイン中のユーザーのプロフィールを返す。アニマルオフィス(OFFICE スコープ)専用で、所属組織には画面全体で使う機能フラグ・メニューの表示などの設定も入れ子で返す。EDI アカウントのプロフィールは edi_profile を使う。
 * @summary プロフィール取得
 */
export const usersProfileRetrieve = async (
  options?: Parameters<typeof customInstance>[1],
): Promise<UserDetail> => {
  return customInstance<UserDetail>(getUsersProfileRetrieveUrl(), {
    ...options,
    method: 'GET',
  });
};

export const getUsersProfileRetrieveQueryKey = () => {
  return ['/api/v2/users/profile'] as const;
};

export const getUsersProfileRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof usersProfileRetrieve>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersProfileRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUsersProfileRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof usersProfileRetrieve>>> = ({ signal }) =>
    usersProfileRetrieve({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof usersProfileRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type UsersProfileRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof usersProfileRetrieve>>>;
export type UsersProfileRetrieveQueryError = ErrorType<StandardizedError | DetailError>;

export function useUsersProfileRetrieve<
  TData = Awaited<ReturnType<typeof usersProfileRetrieve>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersProfileRetrieve>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersProfileRetrieve>>,
          TError,
          Awaited<ReturnType<typeof usersProfileRetrieve>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useUsersProfileRetrieve<
  TData = Awaited<ReturnType<typeof usersProfileRetrieve>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersProfileRetrieve>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersProfileRetrieve>>,
          TError,
          Awaited<ReturnType<typeof usersProfileRetrieve>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useUsersProfileRetrieve<
  TData = Awaited<ReturnType<typeof usersProfileRetrieve>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersProfileRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary プロフィール取得
 */

export function useUsersProfileRetrieve<
  TData = Awaited<ReturnType<typeof usersProfileRetrieve>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersProfileRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getUsersProfileRetrieveQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUsersProfileRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof usersProfileRetrieve>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof usersProfileRetrieve>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUsersProfileRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof usersProfileRetrieve>>> = ({ signal }) =>
    usersProfileRetrieve({ signal, ...requestOptions });

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof usersProfileRetrieve>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } };
};

export type UsersProfileRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof usersProfileRetrieve>>
>;
export type UsersProfileRetrieveSuspenseQueryError = ErrorType<StandardizedError | DetailError>;

export function useUsersProfileRetrieveSuspense<
  TData = Awaited<ReturnType<typeof usersProfileRetrieve>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof usersProfileRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useUsersProfileRetrieveSuspense<
  TData = Awaited<ReturnType<typeof usersProfileRetrieve>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof usersProfileRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useUsersProfileRetrieveSuspense<
  TData = Awaited<ReturnType<typeof usersProfileRetrieve>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof usersProfileRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary プロフィール取得
 */

export function useUsersProfileRetrieveSuspense<
  TData = Awaited<ReturnType<typeof usersProfileRetrieve>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof usersProfileRetrieve>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getUsersProfileRetrieveSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}
